import InfiniteLoader from './infinite-loader'

export default InfiniteLoader
